import React from 'react'
import Switcher from '../Switcher'
import { motion, useScroll } from "framer-motion";
import resume from '../images/cv.pdf'

function Topnav() {
    const { scrollYProgress } = useScroll();
    return (
        <div>
            <motion.div
                className="progress-bar dark:progress-bar"
                style={{ scaleX: scrollYProgress }}
            />
            <nav className={`w-full py-4 bg-[#FFE332] dark:bg-[#10110d]`}>
                <div className="w-full container mx-auto flex flex-wrap items-center justify-between">
                    <nav>
                        <ul className="flex items-center justify-between font-bold text-2xl text-gray-600 dark:text-[#FFE332] no-underline">
                            <li><a className="px-4 custom-font" href="/">Hari</a></li>
                        </ul>
                    </nav>
                    <div className="flex items-center text-sm no-underline text-gray-600 dark:text-[#FFE332] pr-6">
                        <a className="px-4 tracking-widest uppercase text-xs " href={resume} download target="_blank"
                            type="application/octet-stream">Resume</a>
                        <div className="px-4"><Switcher /></div>
                    </div>
                </div>
            </nav>
        </div >
    )
}

export default Topnav
